import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Modal, Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { dateForHumans } from "../../../../utils";

const { TextArea } = Input;

const ApproversModal = ({ open, handleCancel, handleFetchData, prodd }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { approvers, loadingTable } = useSelector((state) => state.dropdown);

  const columns = [
    {
      title: "Approver",
      sorter: (a, b) => a.lavApprover.localeCompare(b.lavApprover),
      dataIndex: "lavApprover",
    },
    {
      title: "Comments",
      sorter: (a, b) =>
        a.lavApprovalComments.localeCompare(b.lavApprovalComments),
      dataIndex: "lavApprovalComments",
    },
    {
      title: "Date",
      sorter: (a, b) => a.lastModifiedDate.localeCompare(b.lastModifiedDate),
      render: (item) => {
        return <div>{dateForHumans(item)}</div>;
      },
      dataIndex: "lastModifiedDate",
    },
    {
      title: "Status",
      dataIndex: "lavStatus",
      render: (item) => {
        const colors = {
          APPROVED: "#2DD683",
          CANCELLED: "#FFAB00",
          REJECTED: "#9D1500",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[5px] px-2 py-1 w-auto"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {item}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={`Approvers for ${prodd?.ppFullname}`}
        open={open}
        onCancel={handleCancel}
        width={850}
        maskClosable={false}
      >
        <Table
          rowSelection={false}
          className="mt-[1.31rem] w-full"
          scroll={{
            x: 800,
          }}
          rowKey={(record) => record?.lavId}
          columns={columns}
          dataSource={approvers}
          loading={loadingTable}
        />
        <div className="flex justify-center items-center mt-[1.25rem]">
          <div className="w-[200px]">
            <button
              key="back"
              type="button"
              onClick={handleCancel}
              className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default ApproversModal;
